import React, { ReactNode } from 'react';

const PageHeader = ({
  title,
  subtitle,
  children,
  className = ''
}: {
  title: string;
  subtitle: string;
  children?: ReactNode;
  className?: string;
}) => {
  return (
    <div className={`flex gap-4 justify-between mb-8 ${className}`}>
      <div>
        <p className='text-[24px] font-semibold mb-1'>{title}</p>
        <p className='text-sm text-[#6F7376]'>{subtitle}</p>
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};

export default PageHeader;
